module.exports = __webpack_public_path__ + "static/media/heatindex_chart_1.c8403a9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WindHeat/heatindex_chart_1.png
// module id = 2523
// module chunks = 0